import React, { useState, useEffect } from "react";
import styles from "./Navbar.module.css";
import * as FaIcons from  "react-icons/fa"
import { useLocation } from "react-router-dom";

function Navbar(props) {
  const location = useLocation();
  const [checked, setchecked] = useState(false);

  const toggleMenu = () => {
    setchecked((prev) => !prev);
    props.showNavHandler((prev) => !prev);
  };


  useEffect(() => {
    setchecked(false);  
    props.showNavHandler(false);
  }, [location]);

    return (
        <>
          <div className={styles.sidebar}>            
            <div className={styles.menu__icon} onClick={toggleMenu}>
              <div
                className={
                  `${styles.line} ` +
                  `${styles.line__1} ` +
                  `${checked ? styles.checked : ""} `  
                  // + `${(isHome == false)  ? styles.dark : ""} `  
                }
              ></div>
              <div
                className={
                  `${styles.line} ` +
                  `${styles.line__2} ` +
                  `${checked ? styles.checked : ""} `
                  //  + `${(isHome == false)  ? styles.dark : ""} `  
                }
              ></div>
              <div
                className={
                  `${styles.line} ` +
                  `${styles.line__3} ` +
                  `${checked ? styles.checked : ""} ` 
                  // + `${(isHome == false)  ? styles.dark : ""} `  
                }
              ></div>
            </div>
   
          </div>
          {/* <Navigation checked={checked} /> */}
        </>
      );
    }
    
    export default Navbar;